import { Ruleset } from "@rosette/ts/src/business/game/Ruleset.js";
import { getRulesetColour } from "../../icon/getRulesetColour.js";


interface RatingLegendProps {
    ratings: Record<string, number>;
}


export function RatingLegend({ ratings }: RatingLegendProps) {

    const legendItems = [Ruleset.FINKEL, Ruleset.BLITZ, Ruleset.MASTERS].map((ruleset) => {
        const rulesetID = ruleset.getID();
        const rating = ratings[rulesetID];
        const name = ruleset.getName();
        const color = getRulesetColour(ruleset);
        let currentRating = "0";
        if (rating) {
            currentRating = `${rating.toFixed(0)}`;
        }
        return { rulesetID, name, color, currentRating };
    });

    return (
        <div className="mb-2 flex flex-wrap gap-[2rem] text-body">
            {legendItems.map(item => (
                <div key={item.rulesetID} className="flex flex-col items-center text-sm">
                    <div className="flex items-center">
                        <span
                            className="mr-1 size-[12px] rounded-[50%]"
                            style={{ backgroundColor: item.color }} />

                        <span className="font-bold">
                            {item.name}
                        </span>
                    </div>
                    <div>
                        {item.currentRating}
                    </div>
                </div>
            ))}
        </div>
    );
}
